/**
 * Harry Potter Bundle — Buy 1 Get 2 Free
 *
 * When the trigger product (Harry Potter Magical Bundle) is in the cart,
 * auto-add the configured quantity of the free gift (Butterbeer Kisses).
 * When the trigger is removed, the free gift is removed too.
 *
 * Upload to: assets/hp-free-gift.js
 */

(function () {
  if (window.__hpFreeGiftInit) return;
  window.__hpFreeGiftInit = true;

  function getConfig() {
    var c = window.HPFreeGiftConfig;
    if (!c || !c.enabled) return null;
    if (!c.triggerProductId || !c.giftVariantId) return null;
    return c;
  }

  /* ---- Cart API helpers ---- */

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('Failed to load cart');
      return r.json();
    });
  }

  function addGift(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: qty }]
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('Failed to add gift');
      return r.json();
    });
  }

  function changeGift(lineKey, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: lineKey, quantity: qty })
    }).then(function (r) {
      if (!r.ok) throw new Error('Failed to change gift');
      return r.json();
    });
  }

  /* ---- Cart UI refresh (iWholesaleCandy theme pattern) ---- */

  function refreshCartUI() {
    /* The IWC theme listens on document.documentElement for these events */
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    } catch (e) {}
  }

  /* ---- Core logic ---- */

  var evaluating = false;

  function evaluate() {
    if (evaluating) return;
    evaluating = true;

    var config = getConfig();
    if (!config) { evaluating = false; return; }

    fetchCart()
      .then(function (cart) {
        /* Count how many of the trigger product are in the cart */
        var triggerQty = 0;
        var giftLine = null;

        (cart.items || []).forEach(function (item) {
          if (Number(item.product_id) === Number(config.triggerProductId)) {
            triggerQty += item.quantity;
          }
          if (Number(item.variant_id) === Number(config.giftVariantId)) {
            giftLine = item;
          }
        });

        /* How many free gifts should be in the cart */
        var targetGiftQty = triggerQty * config.giftQtyPerBundle;

        if (triggerQty > 0 && !giftLine) {
          /* Trigger in cart but no gift yet — add it */
          return addGift(config.giftVariantId, targetGiftQty)
            .then(function () { refreshCartUI(); });

        } else if (triggerQty > 0 && giftLine && giftLine.quantity !== targetGiftQty) {
          /* Gift in cart but wrong quantity — correct it */
          return changeGift(giftLine.key, targetGiftQty)
            .then(function () { refreshCartUI(); });

        } else if (triggerQty === 0 && giftLine) {
          /* Trigger removed from cart — remove the gift */
          return changeGift(giftLine.key, 0)
            .then(function () { refreshCartUI(); });
        }

        /* Otherwise, everything is correct — do nothing */
      })
      .catch(function (err) {
        console.warn('[HP Free Gift]', err);
      })
      .then(function () {
        evaluating = false;
      });
  }

  /* ---- Observers & listeners ---- */

  function observeCartDrawer() {
    /* Watch the IWC cart drawer for DOM changes (qty updates, removals) */
    var target = document.querySelector('.iwc-cart-drawer') ||
                 document.querySelector('#mini-cart') ||
                 document.querySelector('.mini-cart');
    if (!target) return;

    var observer = new MutationObserver(function () {
      clearTimeout(observer._timer);
      observer._timer = setTimeout(function () {
        if (!evaluating) evaluate();
      }, 800);
    });

    observer.observe(target, { childList: true, subtree: true });
  }

  function init() {
    var config = getConfig();
    if (!config) return;

    /* Initial evaluation */
    evaluate();

    /* Watch cart drawer DOM changes */
    observeCartDrawer();

    /* Re-check when the user returns to the tab */
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') evaluate();
    });

    /* Re-check on back/forward cache restore */
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) evaluate();
    });

    /* Listen for the theme's product:added event */
    document.documentElement.addEventListener('product:added', function () {
      setTimeout(function () {
        if (!evaluating) evaluate();
      }, 600);
    });

    /* Listen for cart:refresh event */
    document.documentElement.addEventListener('cart:refresh', function () {
      setTimeout(function () {
        if (!evaluating) evaluate();
      }, 600);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
